import { useParams } from "react-router-dom";
import QuestionBuilderTranslation from "./QuestionBuilderTranslation";

const RegistryFormTranslationBuilder = () => {
  const { formId } = useParams();
  return <QuestionBuilderTranslation formId={formId || ""} type="platform" />;
};

export default RegistryFormTranslationBuilder;
